<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      custom-class="MyDialog"
      :visible.sync="openEntryDialogVisible"
      width="585px"
      :before-close="entryClose"
      label-position:right
      :close-on-click-modal="false"
      v-loading="loading"
    >
      <div style="margin-bottom: 20px">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="ruleFormSty"
        >
          <el-form-item :label="$t('salesCenter.entryQuotaLabel')" prop="remainUseNum">
            <div>{{ remainUseNum }}</div>
          </el-form-item>
          <el-form-item :label="$t('salesCenter.entryOpenCustomerLabel')" prop="showCustomInfo">
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.showCustomInfo"
              :fetch-suggestions="querySearch"
              :placeholder="$t('salesCenter.entryCustomerPlaceholder')"
              :value-key="'showCustomInfo'"
              :trigger-on-focus="false"
              :disabled="entryObj?.customId ? true : false"
              @input="inputChange"
              @select="handleSelect"
            >
            <template slot-scope="{ item }">
              <div v-if="item.customId == ''">{{ $t('salesCenter.entryNoCustomerFound') }}</div>
              <div v-else>{{ item.showCustomInfo }}</div>
            </template>
          </el-autocomplete>
          </el-form-item>
          <!-- <el-form-item :label="$t('app.label')" prop="showCustomInfo">
            <el-select
              v-model="ruleForm.showCustomInfo"
              filterable
              remote
              reserve-keyword
              :placeholder="$t('app.pleaseEnter')"
              :disabled="entryObj?.customId ? true : false"
              :remote-method="querySearch"
              @change="handleSelect"
            >
              <el-option
                v-for="(item, index) in nameOptions"
                :key="index"
                :label="item.showCustomInfo"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('salesCenter.entryExperienceValidityLabel')" prop="dates">
            <div>{{ today }} {{ $t('common.to') }} {{ futureDate }}</div>
          </el-form-item>
          <el-form-item :label="$t('salesCenter.entryLearningMachineLabel')" prop="showSnInfo">
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.showSnInfo"
              :fetch-suggestions="snQuerySearch"
              :placeholder="$t('salesCenter.entryMachinePlaceholder')"
              :value-key="'showSnInfo'"
              :trigger-on-focus="false"
              @input="closeSn"
              @select="snChange"
            >
            <template slot-scope="{ item }">
              <div v-if="item.snCode == ''">{{ $t('salesCenter.entryNoMachineFound') }}</div>
              <div v-else>{{ item.showSnInfo }}</div>
            </template>
            </el-autocomplete>
            <!-- <el-select
              v-model="ruleForm.showSnInfo"
              filterable
              ref="nameSel"
              remote
              reserve-keyword
              :placeholder="$t('app.pleaseEnter')"
              :remote-method="snQuerySearch"
              @change="snChange"
              @blur="handleBlur"
            >
              <el-option
                v-for="(item, index) in snOptions"
                :key="index"
                :label="item.showSnInfo"
                :value="item"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="entryClose">{{ $t('common.cancel') }}</el-button>
        <el-button
          type="primary"
          @click="openEntryConfirm"
          round
          :disabled="!remainUseNum"
          >{{ $t('app.save') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('salesCenter.entryOpenSuccessTitle')"
      custom-class="MyDialog"
      :visible.sync="successDialog"
      width="585px"
      label-position:right
    >
      <el-descriptions
        class="margin-top"
        :column="1"
        labelClassName="w_lableSty"
        contentClassName="w_contentSty"
      >
        <el-descriptions-item :label="$t('salesCenter.entryCustomerNameLabel')">{{
          successObj.name
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('salesCenter.entryCustomerAccountLabel')"
          >{{ successObj.accountUser }}
          <span class="copySty" @click="copyToClipboard(successObj.accountUser)"
            >{{ $t('app.copy') }}</span
          ></el-descriptions-item
        >
        <el-descriptions-item :label="$t('salesCenter.entryPasswordLabel')" :span="20"
          >{{ stu_password }}
          <span class="copySty" @click="copyToClipboard(stu_password)"
            >{{ $t('app.copy') }}</span
          ></el-descriptions-item
        >
        <el-descriptions-item :label="$t('salesCenter.entryExperienceDateLabel')">
          <div>{{ successObj.time }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('salesCenter.entryLearningMachineLabel')">
          <div>{{ successObj.snCode }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentRemainUseNum,
  queryCustomInfo,
  queryMachineInfo,
  openBeginnerAccountInfo,
} from "@/api/AuditionManage";
import { getGwPasswordStr } from "@/api/AccountInterface";
import Template from "@/views/Home/financeCenter/AgentAccount/template.vue";

export default {
  name: "openEntry",
  props: {
    openEntryDialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    entryObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      analystList: [],
      options: [
        {
          value: "1",
          label: this.$t('common.learningMachine'),
        },
        {
          value: "2",
          label: this.$t('common.learningMachine'),
        },
      ],
      nameOptions: [], // Customer name
      snOptions: [], // Learning machine
      successDialog: false,
      loading: false,
      ruleForm: {
        name: "",
        snCode: "",
        showSnInfo: "",
        showCustomInfo: "",
        customId: "",
        mobile: "",
      },
      rules: {},
      today: "",
      futureDate: "",
      remainUseNum: 0, // Remaining use count
      userInfo: {},
      successObj: {}, // Open success info
      stu_password: "",
    };
  },
  components: { Template },
  watch: {
    openEntryDialogVisible(val) {
      console.log(val, "val");

      if (val) {
        this.getAgentRemainUseNum();
        this.snOptions = [];
        this.nameOptions = [];
        this.ruleForm.mobile = this.entryObj?.mobile || "";

        const isName = this.entryObj?.customName || this.entryObj?.studentName;
        this.ruleForm.name = isName || "";
        this.ruleForm.showCustomInfo = isName
          ? `${isName}-${this.entryObj?.mobile}`
          : "";
      } else {
        this.$refs.ruleForm.resetFields();
        this.ruleForm={
             name: "",
        snCode: "",
        showSnInfo: "",
        showCustomInfo: "",
        customId: "",
        mobile: "",
        }
      }
    },
  },
  computed: {
    dialogTitle() {
      return this.title || this.$t('common.openEntryAccount');
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("agent_user_info")) || {};

    this.getCurrentDateTo93DaysLater();
    this.getAgentRemainUseNum();
  },
  methods: {
    // Remote search
    querySearch(query, cb) {
      if (query !== "") {
        let param = {
          campusId: this.entryObj?.campusId || this.userInfo.campusId,
          nameOrMobile: query,
        };
        queryCustomInfo(param)
          .then((res) => {
            if (res.code === 0) {
              this.nameOptions = [];
              if (res.data.length > 0) {
                this.nameOptions = res.data;
              } else {
                this.nameOptions.push({
                  "customId": '',
                  "showCustomInfo": this.$t('common.noCustomerFound')
                })
              }
              console.log(this.nameOptions, "this.nameOptions");
              cb(this.nameOptions);
            }
          })
          .finally(() => {
            this.$nextTick(() => {});
          });
      } else {
        this.nameOptions = [];
      }
    },
    handleBlur(value) {
      console.log(value, "value");

      this.ruleForm.showSnInfo = this.$refs.nameSel.selectedLabelo;
    },
    snQuerySearch(query, cb) {
      if (query !== "") {
        let param = {
          campusId: this.entryObj?.campusId || this.userInfo.campusId,
          machineNameOrSnCode: query,
        };
        queryMachineInfo(param)
          .then((res) => {
            if (res.code === 0) {
              this.snOptions = [];
              if (res.data.length > 0) {
                this.snOptions = res.data;
              } else {
                this.snOptions.push({
                  "snCode": '',
                  "showSnInfo": this.$t('common.noDeviceFound')
                })
              }
              cb(this.snOptions);
            }
          })
          .finally(() => {
            this.$nextTick(() => {});
          });
      } else {
        this.snOptions = [];
      }
    },

    handleSelect(item) {
      if (item.showCustomInfo != this.$t('common.noCustomerFound')) {
        this.ruleForm = {
          ...this.ruleForm,
          ...item,
        };
        console.log(this.ruleForm, "item");
      } else {
        this.ruleForm.showCustomInfo = '';
      }
    },
    inputChange(val){
      this.ruleForm.mobile = '';
      this.ruleForm.name = '';
      this.ruleForm.customId = '';
    },
    snChange(item) {
      if (item.showSnInfo != this.$t('common.noDeviceFound')) {
        this.ruleForm.snCode = item.snCode;
        this.ruleForm.showSnInfo = item.showSnInfo;
      } else {
        this.ruleForm.showSnInfo = '';
      }
      console.log(item, "item");
      // this.ruleForm.showSnInfo = item;
    },
    // Clear SN
    closeSn(val) {
      this.ruleForm.snCode = "";
    },
    getAgentRemainUseNum() {
      getAgentRemainUseNum().then((res) => {
        if (res.code === 0) {
          this.remainUseNum = res.data?.remainUseNum || 0;
        }
      });
    },
    entryClose() {
      this.$emit("entryClose");
    },
    openEntryConfirm() {
      let customId = this.ruleForm?.customId || this.entryObj?.customId || "";
      let snCode = this.ruleForm.snCode;
      if (customId == '') {
        this.$message.warning(this.$t('salesCenter.pleaseEnterCorrectCustomerInfo'));
        return;
      }
      if (snCode == "") {
        this.$message.warning(this.$t('salesCenter.pleaseEnterCorrectMachineInfo'));
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            campusId: this.userInfo.campusId || "",
            customId: this.ruleForm?.customId || this.entryObj?.customId || "",
            mobile: this.ruleForm.mobile || "",
            name: this.ruleForm.name,
            snCode: this.ruleForm.snCode,
          };
          openBeginnerAccountInfo(params)
            .then((res) => {
              if (res.code === 0) {
                this.$nextTick(() => {
                  this.$refs.ruleForm.resetFields();
                });
                this.$emit("openEntryConfirm");
                this.successObj = res.data;
                this.getPasswordStr(res.data.customId);
                this.successDialog = true;
              } else {
                this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    async getPasswordStr(param) {
      const params = {
        customId: param || "",
      };
      await getGwPasswordStr(params).then((ret) => {
        this.stu_password = ret.data;
      });
    },

    getCurrentDateTo93DaysLater() {
      const today = new Date();
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + 93);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.today = formatDate(today);
      this.futureDate = formatDate(futureDate);
      return {
        today: formatDate(today),
        futureDate: formatDate(futureDate),
      };
    },
    // Copy to clipboard
    copyToClipboard(txt) {
      if (navigator.clipboard) {
        // Use clipboard API to copy
        navigator.clipboard.writeText(txt);
      } else {
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        // Hide this input
        textarea.style.position = "fixed";
        textarea.style.clip = "rect(0 0 0 0)";
        textarea.style.top = "10px";
        // Set value
        textarea.value = txt;
        // Select
        textarea.select();
        // Copy
        document.execCommand("copy", true);
        // Remove input
        document.body.removeChild(textarea);
      }

      this.$message.success(this.$t('app.copySuccess'));
    },
  },
};
</script>
<style scoped lang="scss">
.copySty {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
}
.el-select,
.el-autocomplete {
  width: 100%;
}
.el-select-dropdown__item.selected {
  color: #606266;
  font-weight: 400;
}
</style>
<style>
.w_lableSty,
.w_contentSty {
  font-size: 18px;
  color: #000;
  min-width: 150px;
  margin-bottom: 20px;
}
.w_lableSty {
  margin-right: 40px;
}
</style>
